import Vue from "vue";
import VueMoment from "vue-moment";

import VueLuxon from "vue-luxon";

// @ts-ignore
Vue.use(VueLuxon);

Vue.use(VueMoment);
